import cx from 'classnames'
import { FC, useState } from 'react'

import Button from 'src/components/ui/atoms/Button'
import useTracking from 'src/hooks/useTracking'
import SaveAsIcon from '../../atoms/Icons/SaveAsIcon'
import ModalSaveAsDashboard from './ModalSaveAsDashboard'

import * as styles from './PageHeader.scss'

const PageHeaderSaveAsDashboard: FC = () => {
  const { trackEvent } = useTracking()

  const [isModalOpened, setIsModalOpened] = useState(false)

  return (
    <>
      <ModalSaveAsDashboard isOpen={isModalOpened} onClose={() => setIsModalOpened(false)} />
      <Button
        buttonType="silence"
        onClick={() => {
          setIsModalOpened(true)
          trackEvent({ action: 'Click: Save As Dashboard' })
        }}
        className={cx(styles.PageHeaderIcon, 'gap-1.5 !bg-transparent !p-0')}
      >
        <SaveAsIcon />
        <span className="text-sm">Save as</span>
      </Button>
    </>
  )
}

export default PageHeaderSaveAsDashboard
